<div class="toggle-label-wrapper position-relative d-inline-block">
  <p-toggleSwitch
    [formControl]="formControl"
    role="switch"
    [attr.aria-checked]="formControl.value"
    [attr.aria-labelledby]="labelId"
    (onChange)="onToggleChange($event)"
  ></p-toggleSwitch>

  <span
    class="toggle-label w-full fw-bold text-center position-absolute"
    [id]="labelId"
    [ngClass]="formControl.value ? 'yesLabel' : 'noLabel'"
  >
    {{ formControl.value ? YesNoLabels.ON_LABEL : YesNoLabels.OFF_LABEL }}
  </span>
</div>
